import React from "react";
import ServiceDetailLayout from "../../components/service-detail-layout";
import ultrasound from "../../assets/img/ultrasound.jpg";

/**
 * Ultrasound Therapy detail page component
 */
const UltrasoundTherapyDetail = () => {
  return (
    <ServiceDetailLayout
      title="Ultrasound Therapy"
      description="Professional ultrasound therapy for deep tissue injuries. Painless high frequency treatment to speed healing at The Moffat Foot Clinic."
      image={ultrasound}
      imageAlt="Ultrasound Therapy"
    >
      <h1 className="gs-u-mb+">Ultrasound Treatment for Heel Pain</h1>
      <p className="text--large gs-u-mb++">
        If you're dealing with persistent heel discomfort due to issues such as
        plantar fasciitis, seeking a solution that results in betterment and
        alleviation can be both exasperating and difficult.
      </p>

      <p className="gs-u-mb++">
        At The Moffat Foot Clinic, we provide cutting-edge ultrasound therapy
        that has successfully aided numerous individuals suffering from
        persistent foot and ankle pain.
      </p>

      <h2 className="gs-u-mb+">What is ultrasound therapy?</h2>
      <p className="gs-u-mb++">
        High-frequency sound wave therapy employs powerful sound waves aimed at
        specific issues like the plantar fascia, the dense band of tissue
        linking the heel bone to the toes. It can penetrate up to several inches
        beneath the skin, thereby encouraging the healing of the affected
        tissue.
      </p>

      <h2 className="gs-u-mb+">What are the benefits?</h2>
      <p className="gs-u-mb+">
        If you're dealing with plantar fasciitis or any other kind of injury,
        one of the main signs you might experience is inflammation in the
        affected area. Ultrasound therapy can help by boosting blood flow, which
        in turn aids in reducing inflammation. Better blood flow speeds up the
        healing process by providing the tissues with new oxygen and nutrients
        while removing waste.
      </p>

      <p className="gs-u-mb+">
        While you might need to come back for more sessions to keep seeing
        results, this gentle approach is frequently combined with other common
        treatments such as exercises, specially made shoe inserts, taking it
        easy, applying cold packs, getting injections, and taking pain
        relievers.
      </p>

      <p className="gs-u-mb++">
        The best approach to figuring out what will work for your specific
        situation is to talk to a skilled, board-certified foot specialist.
      </p>

      <p className="gs-u-mb++">
        Please contact us to schedule an appointment today!
      </p>
    </ServiceDetailLayout>
  );
};

export default UltrasoundTherapyDetail;
